import type { Papel, Pessoa, PlayerFields, Programa, Unidade } from 'types/pessoa';

/** Categorias de `player_fields__c` que liberam pré-inscrição; `JJ_HIBRIDO` segue bloqueado. */
const PROGRAMA_POR_CATEGORY: Partial<Record<string, Programa>> = {
  CONEXAO: 'PREMIO_CONEXAO',
  JJ_PREDEFINIDO: 'JOGA_JUNTO_PREDEFINIDO',
  ELBB: 'ELBB',
};

const criarUnidade = (prefixo?: number | null, nome?: string | null): Unidade | null =>
  prefixo != null && nome ? { prefixo, nome } : null;

/** Programas da pessoa; quem não está habilitado não tem nenhum. */
export function getProgramas(doc: PlayerFields): Programa[] {
  if (!doc.habilitado) return [];
  const categorias = Array.isArray(doc.category) ? doc.category : [doc.category];
  return categorias
    .map((categoria) => PROGRAMA_POR_CATEGORY[categoria ?? ''])
    .filter((programa): programa is Programa => Boolean(programa));
}

/** Converte o documento de `player_fields__c` no modelo `Pessoa` usado pelas regras do front. */
export function playerFieldsParaPessoa(doc: PlayerFields): Pessoa {
  const papeis: Papel[] = doc.is_manager
    ? [{ papel: 'VALIDADOR_PRE_INSCRICAO', unidade: doc.prefixo, categorias: [] }]
    : [];

  return {
    _id: doc.chave,
    tipo: 'FUNCIONARIO',
    nome: doc.nome,
    nome_guerra: doc.nome_guerra,
    email: doc.email,
    programas: getProgramas(doc),
    funcao: { codigo: doc.cod_funcao, nome: doc.funcao, ro: doc.ro },
    lotacao: {
      prefixo: doc.prefixo,
      nome: doc.nome_dependencia,
      ut: criarUnidade(doc.pref_super, doc.superintendencia),
      ue: criarUnidade(doc.pref_diretoria, doc.diretoria),
    },
    papeis,
  };
}
